import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
  attributes: {},
  avatarUri: '',
  displayLanguage: 'en-US',
  displayName: '',
  email: '',
  firstName: '',
  id: 0,
  lastName: '',
  scopes: [],
  enrolledInUserGuide: false
};
export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {}
});
export default userSlice.reducer;